// extracted by mini-css-extract-plugin
export default {"root":"MultiSelectMobile_root--P4n","select":"MultiSelectMobile_select--QLe"};